<template>
  <sub-page title="我的快递">
    <div class="express-page">
      <!-- 搜索框 -->
      <div class="search-bar">
        <svg viewBox="0 0 24 24" class="search-icon"><circle cx="11" cy="11" r="7" fill="none" stroke="#999" stroke-width="2"/><path d="M16 16 L21 21" stroke="#999" stroke-width="2" stroke-linecap="round"/></svg>
        <input v-model="keyword" class="search-input" placeholder="请输入快递单号搜索" />
      </div>

      <!-- 空状态 -->
      <div class="empty-state">
        <img :src="emptyImg" class="empty-img" alt="empty" />
        <div class="empty-text">暂无快递信息</div>
      </div>
    </div>
  </sub-page>
</template>

<script>
import SubPage from './SubPage.vue'

export default {
  name: 'MyExpress',
  components: { SubPage },
  data() {
    return {
      keyword: '',
      emptyImg: require('@/assets/icons/empty.png')
    }
  }
}
</script>

<style scoped>
.express-page {
  background: #F3F8FB;
  min-height: 100%;
  padding: calc(24 * var(--w));
}
.search-bar {
  display: flex;
  align-items: center;
  height: calc(88 * var(--w));
  background: #fff;
  border-radius: calc(44 * var(--w));
  padding: 0 calc(28 * var(--w));
  gap: calc(12 * var(--w));
  box-shadow: 0 calc(4 * var(--w)) calc(16 * var(--w)) rgba(0, 0, 0, 0.06);
}
.search-icon {
  width: calc(36 * var(--w));
  height: calc(36 * var(--w));
  flex-shrink: 0;
}
.search-input {
  flex: 1;
  border: none;
  outline: none;
  font-size: calc(28 * var(--w));
  color: #323233;
  background: transparent;
}
.search-input::placeholder {
  color: #969799;
}
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: calc(200 * var(--w));
}
.empty-img {
  width: calc(240 * var(--w));
  height: calc(240 * var(--w));
  object-fit: contain;
  opacity: 0.9;
}
.empty-text {
  margin-top: calc(24 * var(--w));
  font-size: calc(30 * var(--w));
  color: #969799;
}
</style>



// WEBPACK FOOTER //
// src/pages/MyExpress.vue